import PassengerType from "../types/PassengerType";
import createDobFromAge from "./createDobFromAge";
const passengerTypeToDob = {
  [PassengerType.Child]: void 0,
  [PassengerType.Youth]: void 0,
  [PassengerType.Adult]: createDobFromAge(35),
  [PassengerType.Senior]: createDobFromAge(65)
};
const createPassengerFromType = (type, age, info) => ({
  ...info,
  type,
  dateOfBirth: typeof age === "number" ? createDobFromAge(age) : passengerTypeToDob[`${type}`]
});
var createPassengerFromType_default = createPassengerFromType;
export {
  createPassengerFromType_default as default,
  passengerTypeToDob
};
